import React from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import CustomTooltip from "../HandleChart/CustomTooltip";
import CustomizedAxisTick from "../HandleChart/CustomizedAxisTick";

const Barchart = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <XAxis
          dataKey="datetime"
          tick={<CustomizedAxisTick axisName="XAxis" />}
          tickLine={false}
          axisLine={false}
        />
        <YAxis
          padding={{ left: 10 }}
          orientation="right"
          tickCount={6}
          //   tick={<CustomizedAxisTick axisName="YAxis" />}
          tickLine={false}
          axisLine={false}
        />
        <CartesianGrid y={100000000} strokeDasharray="0.1" />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="value" barSize={20} fill="#8884d8" />
        <Legend />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default Barchart;
